import { render } from "./DepenseAddEdit.vue?vue&type=template&id=55bc6a40"
import script from "./DepenseAddEdit.vue?vue&type=script&lang=ts"
export * from "./DepenseAddEdit.vue?vue&type=script&lang=ts"
script.render = render

export default script